import { useQuery } from "@tanstack/react-query";
import { useGet } from "../../../common/api-service";
import { RoleModel } from "./types";
import { UserRoles } from "../../../common/enums/user-roles";

const dummyProductRoles: RoleModel[] = [
  {
    id: "UU7btIQJU3Hj4v8Epdi7078Y8SrQ6dmJGn4tetjeL2LhrcdlreuuA3QrmTyqxso/",
    name: "CoGroupAdmin",
    displayName: "Co Group Admin",
    role: UserRoles.CoGroupAdmin,
  },
  {
    id: "KXC1Lr98iTrWsNmG7v5SZrjUoZYNHoDfsVjFspsWl5K6mYXD3I66K9H2vQDzuR4M",
    name: "FacilityAdmin",
    displayName: "Facility Admin",
    role: UserRoles.FacilityAdmin,
  },
  {
    id: "WozAYXmNgl4dp65//JvcWz4s2Y97m+ScEEyZLWsJr9Qcic0bKsflbGbewFpgphzc",
    name: "CoFacilityAdmin",
    displayName: "Co Facility Admin",
    role: UserRoles.CoFacilityAdmin,
  },
  {
    id: "Q0EKy8Ao5jAp/sPAZQYgGNSPIGEJzm+1OQ/JUNWSMorBvgpF4+s0YSHvCE1+WP4p",
    name: "User",
    displayName: "User",
    role: UserRoles.User,
  },
  {
    id: "LIMECTofvvlZ7JN3sLocWGa7zxWx6hBrcJNq8HzUvqg8qMA13yxiFJhoCSKPF23L",
    name: "BizboxUser",
    displayName: "Bizbox User",
    role: UserRoles.BizboxUser,
  },
];

const dummyRole: RoleModel[] = [
  {
    id: "MdVG+7STzVF6NwhGgu78DTAr8YYKs65F9mNvBtV/RR6um0Zg8bQj1fy+7MMATrpI",
    name: "GroupAdmin",
    displayName: "Group Admin",
    role: UserRoles.GroupAdmin,
  },
  {
    id: "UU7btIQJU3Hj4v8Epdi7078Y8SrQ6dmJGn4tetjeL2LhrcdlreuuA3QrmTyqxso/",
    name: "CoGroupAdmin",
    displayName: "Co Group Admin",
    role: UserRoles.CoGroupAdmin,
  },
];

const dummyInternalRole: RoleModel[] = [
  {
    id: "BIZBXAdm1nDummyWalkthroughR0l3Id000000000000000000000000000000000000",
    name: "BizboxAdmin",
    displayName: "Bizbox Admin",
    role: UserRoles.BizboxAdmin,
  },
  {
    id: "BIZBXUsr1DummyWalkthroughR0l3Id0000000000000000000000000000000000000",
    name: "BizboxUser",
    displayName: "Bizbox User",
    role: UserRoles.BizboxUser,
  },
];

export const useGetProductRoles = (
  productCode: string,
  walkthroughMode?: boolean
) => {
  const { get } = useGet();
  var url = `/api/roles/product-roles?ProductCode=${productCode}`;

  return useQuery<RoleModel[]>({
    queryFn: () => {
      if (walkthroughMode) {
        console.log("walkthroughMode - returning dummyProductRoles");
        return Promise.resolve(dummyProductRoles);
      }
      return get<RoleModel[]>(url);
    },
    queryKey: ["product-roles", { productCode, walkthroughMode }],
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 0,
  });
};

//Roles Dropdown for User Management
export const useGetRoles = (isInternal: boolean, walkthroughMode?: boolean) => {
  const { get } = useGet();
  var url = `/api/roles/all-roles?IsInternal=${isInternal}`;
  return useQuery<RoleModel[]>({
    queryFn: () => {
      if (walkthroughMode) {
        console.log("walkthroughMode - returning dummyRole");
        return Promise.resolve(isInternal ? dummyInternalRole : dummyRole);
      }
      return get<RoleModel[]>(url);
    },
    queryKey: ["all-roles", { isInternal, walkthroughMode }],
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 0,
  });
};
